<template>
  <div class="telephone-bids-list tab-table p-2">
    <TelephoneBidsTable/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import TelephoneBidsTable from '../../../telephone-bids/TelephoneBidsTable'
  const {mapState} = createNamespacedHelpers('sales');
  const {mapActions: telephoneBidsMapActions} = createNamespacedHelpers('telephoneBids');

  export default {
    name: "TelephoneBidsList",
    components: {TelephoneBidsTable},
    computed: {
      ...mapState({
        sale: state => state.view.currentSale
      })
    },
    methods: {
      ...telephoneBidsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'sale',
        extraFilters: {auction_uuid: this.sale.uuid, with_telephone_bids: true},
        sale: this.sale
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
